import {useEffect, useState} from 'react'

export const DelayedComponent = ({
  children,
  delay = 500,
  assertive = false,
}: {
  children: React.ReactNode
  delay?: number
  assertive?: boolean
}) => {
  const [shouldAnnounce, setShouldAnnounce] = useState(false)

  useEffect(() => {
    setShouldAnnounce(false)
    const timer = setTimeout(() => setShouldAnnounce(true), delay)
    return () => clearTimeout(timer)
  }, [delay, setShouldAnnounce])

  if (!shouldAnnounce) return null

  return (
    <div role="alert" aria-live={assertive ? 'assertive' : 'polite'} aria-atomic="true">
      {children}
    </div>
  )
}

try{ DelayedComponent.displayName ||= 'DelayedComponent' } catch {}